import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';

/**
 * Renders CMS seasonal notice with optional mailto link for contactEmail.
 */
export function renderSeasonalNotice(notice) {
  if (!notice?.message) return null;

  const { message, contactName, contactEmail } = notice;

  return (
    <>
      <FaInfoCircle />
      {contactEmail ? (
        <span>
          {message}{' '}
          {contactName ? `${contactName}, at ` : 'at '}
          <a href={`mailto:${contactEmail}`} className="form-seasonal-notice-link">
            {contactEmail}
          </a>
          .
        </span>
      ) : (
        <span>{message}</span>
      )}
    </>
  );
}
